/**
 * Message control for someone you are friends with.
 * Icon-only on cards and hover previews. Pass `label` on the profile page.
 */

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useBlockContext } from '../hooks/useBlockContext';
import { Button } from './Button';
import { Icon } from '../icons/Icon';
import { Tooltip } from './Tooltip';

export function MessageFriendButton({
  identityId,
  label,
}: {
  identityId: string;
  /** Visible text. Omit for the icon-only control used on cards and hover previews. */
  label?: string;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isBlocked } = useBlockContext();

  if (isBlocked(identityId)) return null;

  const iconLabel = t('identityCard.message');

  return (
    <Tooltip content={label ? undefined : iconLabel}>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        className={label ? undefined : 'message-friend-btn'}
        aria-label={label ? undefined : iconLabel}
        onClick={() =>
          navigate('/conversations/new', {
            state: { preSelectedIds: [identityId] },
          })
        }
      >
        <Icon name="message" />
        {label}
      </Button>
    </Tooltip>
  );
}
